import {connect} from 'react-redux';
import axios from 'axios';

import store from "../../../../redux/store";
import {typeExport} from "../../../../redux/store/type";

import {Platform} from "react-native";

import i18n from "../../../../I18n/i18n";

import * as NavigationService from "../../../../redux/NavigationService";
import SubmitRequestOperationFireScreen from "../SubmitRequestOperationFireScreen";
import HMAlert from "../../../../customviews/HMAlert";


const mapStateToProps = (state) => ({
    results: state.reducerSubmitRequestOperationFireScreen.results,
    isLoading: state.reducerSubmitRequestOperationFireScreen.isLoading,
    NoInternetDialog: state.reducerSubmitRequestOperationFireScreen.NoInternetDialog,

    resultsSet: state.reducerSubmitRequestOperationFireScreen.resultsSet,
    isLoadingSet: state.reducerSubmitRequestOperationFireScreen.isLoadingSet,
    NoInternetDialogSet: state.reducerSubmitRequestOperationFireScreen.NoInternetDialogSet,

    position: state.reducerSubmitRequestOperationFireScreen.position,
    id_category: state.reducerSubmitRequestOperationFireScreen.id_category,


    positionPersonnel: state.reducerSubmitRequestOperationFireScreen.positionPersonnel,
    id_Personnel: state.reducerSubmitRequestOperationFireScreen.id_Personnel,

    CartList: state.reducerSplashGetAllData.CartList,
    PriceAll: state.reducerSplashGetAllData.PriceAll,

    user: state.reducerSplashGetAllData.user,
    wallet: state.reducerSplashGetAllData.wallet,
    data_splash: state.reducerSplashGetAllData,
    // token: state.reducerSplash.token,

    FoodItem: state.reducerSplashGetAllData.FoodItem,
});

const mapDispatchToProps = (dispatch, getState) => ({
    callService: (url, params, type, typeConnection, token, item, index) => dispatch(callWebservice(getState, url, params, type, typeConnection, token, item, index)),

    callserviceActionRefresh: () => dispatch(serviceActionRefresh()),

});

const getDataDisatch = (dispatch, getState, url, params, type, typeConnection, token, item, index) => {

    let {NotSendListOperatorApply} = store.getState().reducerSplashGetAllData;
    switch (type) {
        case typeExport.TypeGetSubmitRequestOperationFireScreen:
            dispatch(serviceActionPending());

            break;

        case typeExport.TypeSetSubmitRequestOperationFireScreen:
            dispatch(serviceActionPendingSet());

            break;

        default:
    }

    let DateTime = new Date().getTime()

    let nameImage = DateTime + '.jpg';
    let nameVideo = DateTime + '.mp4';
    let nameAudio = DateTime + '.aac';

    const formData = new FormData();
    formData.append('_operation', typeExport._Fire);
    formData.append('mode', 'UploadFile');
    formData.append('lang', params.lang);
    formData.append('token', params.token);
    //  formData.append('_session', params._session);
    //  formData.append('record', params.record);
    //   formData.append('status', params.status);
    formData.append('comment', params.comment);
    formData.append('AnswerComment', params.AnswerComment);
    formData.append('code', params.code);
    formData.append("device", global._Device ? global._Device.value : null);


    if (params.audio && params.audio !== null) {
        formData.append('durationVoice', params.durationVoice);

        if (Platform.OS === "web") {
            //  formData.append('audio', params.audio, nameAudio + ".aac");
            formData.append('audio', params.audioBlob, nameAudio);
            //const blobFile = new File([params.audio], nameAudio + ".aac");
            //formData.append("audio", params.audioBlob);
        }
        else
            formData.append('audio', {
                uri: params.audio,
                name: nameAudio,
                type: 'audio/aac'
            });
    }

    // if (params.image && params.image !== null)
    //     if (Platform.OS === "web") {
    //         formData.append('image', params.image, nameImage );
    //
    //     }
    //     else
    //         formData.append('image', {
    //             uri: params.image,
    //             name: nameImage,
    //             type: 'image/jpeg'
    //         });
    if (params.video && params.video !== null) {
        if (Platform.OS === "web") {
            //  formData.append('audio', params.audio, nameAudio + ".aac");
            formData.append('video', params.video, nameVideo);
            //const blobFile = new File([params.audio], nameAudio + ".aac");
            //formData.append("audio", params.audioBlob);
        }
        else
            formData.append('video', {
                uri: params.video,
                name: nameVideo,
                type: 'video/mp4'
            });
    }
    /*    if (params.video && params.video !== null) formData.append('video', {
            uri: params.video,
            name: nameVideo,
            type: 'video/mp4'
        });*/
    for (let i = 0; i < params.arrImage.length; i++) {


        if (Platform.OS === "web") {
            formData.append('image' + "_" + i, params.arrImage[i], `${i}_${nameImage}`);
        }
        else

            formData.append('image' + "_" + i, {
                uri: params.arrImage[i],
                name: nameImage,
                type: 'image/jpeg'
            });
    }
    for (let i = 0; i < params.arrFile?.length; i++) {

        var file = params.arrFile[i];
        if (Platform.OS === 'web') {
            formData.append('file' + '_' + i, file, `${i}_${DateTime}+${file.name}`);
        }
        else {
            formData.append('file' + '_' + i, {
                uri: file,
                name: `${i}_${DateTime}+${file.name}`,
                type: 'text/plain',
            });
        }
    }

    // formData.append('subject', params.subject);
    // formData.append('subjectid', params.subjectid);
    /*    if (params.audio && params.audio !== null) formData.append('audio', {
            uri: params.audio,
            name: nameAudio,
            type: 'audio/aac'
        });
        // if (params.image && params.image !== null) formData.append('image', {
        //     uri: params.image,
        //     name: nameImage,
        //     type: 'image/jpeg'
        // });
        if (params.video && params.video !== null) formData.append('video', {
            uri: params.video,
            name: nameVideo,
            type: 'video/mp4'
        });

        for (let i = 0; i < params.arrImage.length; i++) {
            formData.append('image'+ "_" + i, {
                uri: params.arrImage[i],
                name: nameImage ,
                type: 'image/jpeg'
            });
        }*/
    // formData.append('description', params.description);
    // formData.append('address', params.address);
    // formData.append('longitude', params.longitude);
    // formData.append('latitude', params.latitude);
    // formData.append('private', params.private);
    formData.append('platform', Platform.OS);

    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            // 'Content-Type': 'application/json',
            //  "Authorization": `Basic ${params.token}`,
            timeout: params.video !== null ? typeExport._TIMEOUT_FILE : typeExport._TIMEOUT,
        }
    };
    /*    axios(
            {
                url: baseUrl + url + params,
                method: typeConnection,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                /!*      headers: {'X-Requested-With': 'XMLHttpRequest'},*!/
            }
        )*/

    axios.post(url, formData, config)
        .then(async response => {

            let data = response.data;

            //let obj=null;
            // let obj = {
            //     address: params.address,
            //     code: "_",
            //     color: "#ff0000",
            //     comment: [],
            //     createdtime: params.date,
            //     image: params.image,
            //     video: params.video,
            //     audio:(params.audio && params.audio !== null)? params.audio:null,
            //     platform: Platform.OS,
            //     /*    files: [
            //             {
            //                 file: params.image,
            //                 type: "image/jpeg"
            //             },
            //             {
            //                 file: params.video,
            //                 type: "video/mp4"
            //             },
            //         ],*/
            //     latitude: params.latitude,
            //     longitude: params.longitude,
            //     status: i18n.t('constant.registrated'),
            //     title: params.subject,
            //     subjectid: params.subjectid
            // };

            switch (type) {
                case typeExport.TypeGetSubmitRequestOperationFireScreen:

                    break;

                case typeExport.TypeSetSubmitRequestOperationFireScreen:
                    if (response.data.success === true) {
                        // dispatch(serviceActionSuccess(data, token, response.data.user));
                        // global.list_menu_shahrdar = response.data.result.menu
                        dispatch(serviceActionSuccessSet(data));
                        HMAlert(
                            i18n.t('constant.message'),
                            i18n.t('constant.RequestSuccessfullyRegistered') + (item ? '\n' + i18n.t('constant.updateTheList') : ''),
                            [
                                {
                                    text: (item ? i18n.t('constant.ok') : i18n.t('constant.ok')),
                                    onPress: () => {
                                        global.onRefreshDetailsOperatorFireApplyScreen = true
                                        NavigationService.BackTo(1)

                                    }


                                },
                                item ? {
                                    text: i18n.t('constant.NowNot'),
                                    onPress: () => {
                                    },
                                    style: 'cancel'
                                } : null,




                            ],
                            {cancelable: false}
                        )
                        // if (item) {
                        //
                        //     NotSendListOperatorApply.splice(index, 1);
                        //     await AsyngStorageClass.setAsyng(global.IdCity + typeExport.ListOperatorApplyOffline +item.type, NotSendListOperatorApply);
                        //     store.dispatch(serviceActionNotSendListOperatorApply(NotSendListOperatorApply));
                        //
                        //
                        //     // let arr = await AsyngStorageClass.getASyng(typeExport.ListOperatorApply + params.type)
                        //     // await AsyngStorageClass.setAsyng(typeExport.ListOperatorApply + params.type, [obj, ...arr])
                        //
                        //     let arr = await AsyngStorageClass.getASyng(global.IdCity  +typeExport.ListOperatorApply+ item.type)
                        //     await AsyngStorageClass.setAsyng(global.IdCity +typeExport.ListOperatorApply + item.type, [obj, ...arr])
                        //     store.dispatch(serviceActionAddSubList([obj, ...store.getState().reducerListOperatorApplyScreen.results]))
                        //
                        // }


                        //   NavigationService.navigatereset('MainStack');
                    } else {

                        dispatch(serviceActionRefresh());
                        alert(response.data.error && response.data.error.message ? response.data.error.message : i18n.t('constant.ServerEncounteredProblemTryingAgain'))
                        //   NavigationService.navigatereset('LoginStack');
                    }
                    break;

                default:
            }
        }).catch((e) => {

        console.log(e);

        switch (type) {
            case typeExport.TypeGetSubmitRequestOperationFireScreen:
                dispatch(serviceActionError(e))

                break;

            case typeExport.TypeSetSubmitRequestOperationFireScreen:
                dispatch(serviceActionErrorSet(e))

                break;

            default:
        }
    })
}


// export const callSetStateCity =  (state_name,state_id,city_name,city_id)  => {

//     return dispatch (serviceActionSuccessSetCityStateData (state_name,state_id,city_name,city_id) )
// }
export const callWebservice = (getState, url, params, type, typeConnection, token, item, index) => {
    return dispatch => {
        //
        // // if (Platform.OS === 'ios') {
        // //     NetInfo.isConnected.addEventListener('connectionChange', (isConnected) => {
        // //             if (isConnected) {
        // //                 getDataDisatch(dispatch, getState ,url, params, type, typeConnection, token, item,index);
        // //             }
        // //             else {
        // //                 dispatch(serviceActionError("No Internet Connection"));
        // //             }
        // //         }
        // //     );
        // // }
        // // else {
        //     NetInfo.isConnected.fetch().then(isConnected => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, getState ,url, params, type, typeConnection, token, item,index);
        //         }
        //         else {
        //             switch (type) {
        //
        //                 case TypegetSubmitRequestOperationFireScreen:
        //                     dispatch(serviceActionError("no connect"));
        //                     break;
        //                 default:
        //             }
        //         }
        //     });
        // //}

        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, getState, url, params, type, typeConnection, token, item, index);
        //         } else {
        //             switch (type) {
        //
        //                 case typeExport.TypeGetSubmitRequestOperationFireScreen:
        //                     dispatch(serviceActionError("no connect"));
        //                     break;
        //                 default:
        //             }
        //         }
        //     }
        // )

        if (store.getState().reducerSplashGetAllData.Connection) {
            getDataDisatch(dispatch, getState, url, params, type, typeConnection, token, item, index);
        } else {
            switch (type) {
                case typeExport.TypeGetSubmitRequestOperationFireScreen:
                    dispatch(serviceActionError('error_Connection'))

                    break;

                case typeExport.TypeSetSubmitRequestOperationFireScreen:
                    dispatch(serviceActionErrorSet('error_Connection'))

                    break;

                default:
            }
        }

    }
}


export const serviceActionPending = () => ({
    type: typeExport.SubmitRequestOperationFireScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    showDialohCity: false

})

export const serviceActionError = (error) => ({
    type: typeExport.SubmitRequestOperationFireScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    error: error,
    isLoading: false,
    showDialohCity: false

})

export const serviceActionSuccess = (data) => ({
    type: typeExport.SubmitRequestOperationFireScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    results: data,
    isLoading: false,
})

export const serviceActionPendingSet = () => ({
    type: typeExport.SubmitRequestOperationFireScreen_SERVICE_PENDING_Set,
    NoInternetDialogSet: false,
    isLoadingSet: true,

})

export const serviceActionErrorSet = (error) => ({
    type: typeExport.SubmitRequestOperationFireScreen_SERVICE_ERROR_Set,
    NoInternetDialogSet: true,
    error: error,
    isLoadingSet: false,

})

export const serviceActionSuccessSet = (data) => ({
    type: typeExport.SubmitRequestOperationFireScreen_SERVICE_SUCCESS_Set,
    NoInternetDialogSet: false,
    resultsSet: data,
    isLoadingSet: false,
})
export const serviceActionRefresh = () => ({
    type: typeExport.SubmitRequestOperationFireScreen_SERVICE_REFRESH,
    NoInternetDialog: false,
    results: null,
    isLoading: false,
})


export default connect(mapStateToProps, mapDispatchToProps)(SubmitRequestOperationFireScreen);
